<template>
  <div>
    <training-toolbar v-if="userInfo"/>
    <div class="card mx-md-5 mt-3 mb-3 bg-form">
      <card-header v-if="userInfo"
        :title="isAdmin || isTrainingAdmin ? $t('training-add.title') : $t('training-add.proposeTitle')"
        :iconName="'plus-circle-fill'"
      />
      <b-card-body>
        <b-alert variant="success" v-model="popSuccessAlert" dismissible> {{ this.successMessage }} </b-alert>
        <b-alert v-for="error in errors" :key="error.message" v-model="popAlert"  variant="danger" dismissible>
          {{ error.message }}
        </b-alert>

        <template>
          <training-license-form :activity="emptyActivity" v-on:error:api.capture="handleError"/>
        </template>
      </b-card-body>
    </div>
  </div>
</template>

<script>
import CardHeader from '../../components/common/cardHeader.vue'
import TrainingLicenseForm from '../../components/training/trainingLicenseForm'
import trainingService from '../../services/training.service';
import { handleApiError } from '../../services/error.service';
import TrainingToolbar from '../../components/common/trainingToolbar.vue';
import {hasRole} from "esep/src/services/utils";
import {roles, routes} from "esep/src/services/routing.service";


export default {
  components: {
    CardHeader,
    TrainingLicenseForm,
    TrainingToolbar
  },
  mounted() {
    trainingService.getUserInfo(this.username).then(
      (response) => {
        this.userInfo = response.data;
        if (!hasRole(this.userInfo,roles.training.trainings)){
          location.replace(routes.nothing);
        }
        this.$store.state.userInfo = this.userInfo;
        this.fetchRoles();
      },
      (error) => {
        let errorMessage = handleApiError(error);
        this.handleError(errorMessage);
      }
    );
  },
  data() {
    return {
      userInfo: null,
      popSuccessAlert: false,
      popAlert: false,
      successMessage: null,
      errors: null,
      emptyActivity: {
        paymentTypes: [],
        module: {
          id: null,
          billMethod: {
            rules: [
              { billingValue: 0 }
            ]
          }
        },
        orgUnit: {
          id: null,
          name: this.$t('common.unit-selector.selectAUnit')
        },
        method: 'LIVE',
        status: 'TO_BE_CREATED',
        applicationsDate: null,
        periods: [],
        leaders: [],
        trainingLeader: {

          label: null,
          id: null,
          cinfo: {
            telNo: null,
            cellNo: null,
            email: null
          }
          
        },
      },
      isAdmin: false,
      isTrainingAdmin: false,
      isTrainingMod: false
    }
  }, 
  methods: {
    handleError(errors) {
      errors.forEach(error => {
        error.message = this.$t(`error.${error.code}`);
      })
      this.errors = errors;
      this.popAlert = errors.length>0;
    },
    fetchRoles() {
      for(var i=0; i< this.userInfo.roles.length; i++){
        if(this.userInfo.roles[i].name == "ADMIN" ) {
          this.isAdmin = true;
        } else if(this.userInfo.roles[i].name == "TRAINING_ADMIN") {
          this.isTrainingAdmin = true;
        } else if(this.userInfo.roles[i].name == "TRAINING_MOD"){
          this.isTrainingMod = true;
        }
      }
    }
  }
}
</script>